import { css, html, LitElement, unsafeCSS } from 'lit';
import styles from './stack.scss?inline';

export default class SotbitStack extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    render() {
        return html`
            <div class="stack__container" part="stack-container">
                <slot></slot>
            </div>
        `;
    }
}
